module.exports = __webpack_public_path__ + "assets/img/proteus.e3b05358.png";